import dayjs from "dayjs";
import { DataTable } from "../DataTable";
import { Badge, Group, MultiSelect, Tooltip, Text } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

const statusBadgeColors = {
  sent: "gray",
  delivered: "green",
  opened: "blue",
  failed: "red",
};

const formatDate = (date) => {
  return date ? dayjs(date).format("DD.MM.YYYY. [at] HH:mm") : "-";
};

const CampaignLogsTable = ({
  records,
  fetching,
  page,
  recordsPerPage,
  totalRecords,
  onPageChange,
  statusFilter,
  handleStatusFilterChange,
}) => {
  const columns = [
    {
      accessor: "recipient",
    },
    {
      accessor: "status",
      filtering: statusFilter.length > 0,
      filter: (
        <MultiSelect
          label="status"
          placeholder="Filter by status"
          value={statusFilter}
          data={[
            { value: "sent", label: "Sent" },
            { value: "delivered", label: "Delivered" },
            { value: "opened", label: "Opened" },
            { value: "failed", label: "Failed" },
          ]}
          onChange={(value) => {
            handleStatusFilterChange(value);
          }}
          clearable
        />
      ),
      render: (row) => {
        const timestampByStatus = {
          sent: row.sentAt,
          delivered: row.deliveredAt,
          opened: row.openedAt,
        };
        const timestamp = timestampByStatus[row.status];

        return (
          <Group wrap="nowrap">
            <Badge
              color={statusBadgeColors[row.status]}
              style={{ flexShrink: 0 }}
            >
              {row.status}
            </Badge>
            {row.status === "failed" && row.error?.message ? (
              <Tooltip label={row.error.message} multiline maw={300}>
                <Text
                  size="sm"
                  c="red"
                  lineClamp={1}
                  style={{ cursor: "pointer" }}
                >
                  <IconAlertCircle
                    size={14}
                    style={{ marginRight: 4, verticalAlign: "middle" }}
                  />
                  {row.error.message}
                </Text>
              </Tooltip>
            ) : (
              timestamp && <Text size="sm">{formatDate(timestamp)}</Text>
            )}
          </Group>
        );
      },
    },
  ];

  return (
    <DataTable
      records={records}
      columns={columns}
      fetching={fetching}
      page={page}
      recordsPerPage={recordsPerPage}
      totalRecords={totalRecords}
      onPageChange={onPageChange}
      statusFilter={statusFilter}
      handleStatusFilterChange={handleStatusFilterChange}
      borderRadius="md"
      verticalSpacing="md"
    />
  );
};

export default CampaignLogsTable;
